export interface Reservation {
  id: string;
  store: string;
  type: '同伴' | '確約' | '予約';
  date: string;
  time: string;
  dayOfWeek: string;
  customerType: string;
  customerId: string;
  customerName: string;
  guestCount: string;
  company?: string;
  points?: number;
  isPast?: boolean;
}

export interface ReservationStats {
  year: { 同伴: number; 確約: number; 予約: number };
  allTime: { 同伴: number; 確約: number; 予約: number };
}

/**
 * 予約タイプを決定する
 * booking_type は 3 値。予約を持たない来店は予約一覧に出ない（ADR 20260902）。
 * @param bookingType - booking_type カラムの値
 */
export function getReservationType(
  bookingType: string | null
): '同伴' | '確約' | '予約' {
  switch (bookingType) {
    case 'accompanied_confirmed':
      return '同伴';
    case 'reservation_confirmed':
      return '確約';
    default:
      return '予約';
  }
}
